<script setup lang="ts">
/***
 * template to show object fields as key-value pairs in two columns
 */
const _props = defineProps<DataTableCellProps>();
import { useI18n } from 'vue-i18n';

import type { DataTableCellProps } from './templateTypes';
const { t } = useI18n();
</script>

<template>
  <i
    v-tooltip="{
      value:
        cell.meta('rawvalue') === 'actual'
          ? t('titletags.costInvoiceActual')
          : t('titletags.costInvoiceDraft'),
      showDelay: 300,
    }"
    :class="[
      'mdi text-xl',
      cell.meta('rawvalue') === 'actual'
        ? 'mdi-cash-100 text-interactiongreen-600'
        : 'mdi-cash-multiple text-neutral-400',
    ]"
  ></i>
</template>
